var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-maxlength-label",style:(_vm.maxLabelStyle())},[_vm._v("\n    "+_vm._s((_vm.value + "").length)+"/"+_vm._s(_vm.maxLength)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/formVue/commponents/go-max-length-label.vue